<template>
  <div class="list-box">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="付款操作"
    ></div>
    <div class="flex-1 flex flex-col relative overflow-hidden">
      <ul
        class="flex items-center justify-end p-2.5 gap-x-3 absolute right-0"
        style="top: -10px"
      >
        <el-segmented
          v-model="state.params.status"
          :props="{
            label: 'Text',
            value: 'Key',
          }"
          :options="[
            { Key: 1, Text: '待付款' },
            { Key: 2, Text: '已付款' },
          ]"
          :empty-values="[null, undefined, 0]"
          class="c-segmented"
        />
        <el-input
          v-model="state.params.keywords"
          class="c-search-white !w-56"
          clearable
          placeholder="关键字"
          @keyup.enter="onLoad()"
          @clear="onLoad()"
        >
          <template #suffix>
            <el-icon
              @click="onLoad()"
              color="#a2a2a2"
              title="搜索"
              class="font-bold cursor-pointer hover:opacity-60"
              ><Search
            /></el-icon>
          </template>
        </el-input>
      </ul>
      <el-tabs v-model="state.type" class="c-el-tabs-auto-height">
        <el-tab-pane label="采购付款" name="caigou">
          <c_caigou
            v-if="state.type == 'caigou'"
            :params="state.params"
            :key="state.params?.status"
          />
        </el-tab-pane>
        <el-tab-pane label="无采购付款" name="wucaigou">
          <c_wucaigou
            v-if="state.type == 'wucaigou'"
            :params="state.params"
            :key="state.params.status"
          />
        </el-tab-pane>
        <el-tab-pane label="办公费用付款" name="feiyong">
          <c_feiyong
            v-if="state.type == 'feiyong'"
            :params="state.params"
            :key="state.params.status"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

import c_caigou from "./CaiGouFuKuan.vue";
import c_wucaigou from "./WuCaiGouFuKuan.vue";
import c_feiyong from "./FeiYongFuKuan.vue";

export default {
  components: {
    c_caigou,
    c_wucaigou,
    c_feiyong,
  },
  setup() {
    const state = reactive({
      type: "caigou",
      params: {
        status: 1,
      },
    });
    onMounted(() => {});

    return {
      state,
    };
  },
};
</script>

<style lang="scss" scoped></style>
